import CouponModal from './CouponModal';

export default (props) => {
  return <CouponModal {...props} />;
};
